<!-- Conference view – shown after SEB instructions are dismissed -->
<app-audio-video-conference *ngIf="!isLoading && !showSEBInstructions"
    [candidateId]="candidateId"
    [jobId]="jobId"
    [jobMatchId]="jobMatchId"
    [scheduleId]="scheduleId"
    [scheduleInfo]="scheduleInfo"
    [participantType]="'c'"
    [workflowStep]="workflowStep"
    [mode]="mode">
</app-audio-video-conference>

<!-- Safe Assessment Browser instructions – shown before entering the meeting -->
<div class="seb-page" *ngIf="!isLoading && showSEBInstructions">
  <div class="container">
    <div class="row d-flex justify-content-center meeting-full-height">
      <div class="col-md-10">

        <div class="main-box">

          <div class="main-box-header with-border">
            <h3 class="font-bold pl-0">{{workflowStepName}}</h3>
            <div class="row mt-2" *ngIf="scheduleInfo">
              <div class="col-xs-12">
                <span class="meeting-details-label">Scheduled Date:</span>
                <span>{{ scheduleInfo.scheduledDate | fourDotFiveDateFormatPipe }}, {{ scheduleInfo.scheduledTimeLabel }}</span>
                <span *ngIf="scheduleInfo.timeZone != '-'">&nbsp; in {{ scheduleInfo.timeZone }}</span>
              </div>
              <div class="col-xs-12">
                <span class="meeting-details-label">Mode:</span>
                <span *ngIf="mode == 'VIDEO'">Video</span>
                <span *ngIf="mode == 'AUDIO'">Audio</span>
                <span *ngIf="mode == 'PHONE'">Phone</span>
              </div>
            </div>
            <p class="mt-2">
              This session is conducted in Safe Assessment Browser. Please <strong>complete the following steps</strong> in the given order to join. If you have already installed the safe assessment
              browser installer, you can
              <a href (click)="attemptTest(); $event.preventDefault()"><strong>skip to Step 3.</strong></a>
            </p>
          </div>

          <div class="main-box-body">

            <div class="row mt-4">

              <!-- Step 1 -->
              <div class="col-md-4" style="padding-right: 30px;">
                <p class="seb-step-label pl-2">Step 1</p>
                <div class="seb-step-body">
                  <div class="seb-icon-circle">
                    <div><i class="fa fa-download"></i></div>
                  </div>
                  <div class="seb-step-content">
                    <h5 class="emerald">Download the Safe assessment browser installer</h5>
                    <p>Click on Download to <strong>download the safe assessment browser</strong> installer file.</p>
                    <a [href]="sebDownloadUrl" target="_blank" rel="noopener" class="btn btn-primary">Download</a>
                  </div>
                </div>
              </div>

              <!-- Step 2 -->
              <div class="col-md-4" style="padding-right: 30px;">
                <p class="seb-step-label pl-2">Step 2</p>
                <div class="seb-step-body">
                  <div class="seb-icon-circle">
                    <div><i class="fa fa-cog"></i></div>
                  </div>
                  <div class="seb-step-content">
                    <h5 class="emerald">Complete the installation process</h5>
                    <p>
                      After downloading the installer, <strong>complete the installation process.</strong>
                      In certain browsers, it might install automatically; if not, manually install the downloaded file.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Step 3 -->
              <div class="col-md-4">
                <p class="seb-step-label pl-2">Step 3</p>
                <div class="seb-step-body">
                  <div class="seb-icon-circle">
                    <div><i class="fas fa-file-alt"></i></div>
                  </div>
                  <div class="seb-step-content">
                    <h5 class="emerald">Continue</h5>
                    <p>After installation is successful, click Continue to open the Safe Assessment Browser. You'll join your {{workflowStepName.toLowerCase()}} from there. Good Luck!</p>
                    <button class="btn btn-primary" (click)="attemptTest()">Continue</button>
                  </div>
                </div>
              </div>

            </div><!-- /row -->

            <!-- Footer note -->
            <div class="row mt-4">
              <div class="col-md-12">
                <div class="seb-footer-note">
                  <strong>Note:</strong>
                  Safe Assessment Browser will automatically close all running applications upon launch. Please save all your work and close any open programs manually before proceeding; otherwise, you may lose unsaved data. Your {{workflowStepName.toLowerCase()}} will then open in the safe assessment browser window.
                  To know more about the Safe Assessment mode
                  <a [href]="sebInfoUrl" target="_blank" rel="noopener">Click here &rarr;</a>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>
